'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.control = control;

var _reduxShip = require('redux-ship');

var Ship = _interopRequireWildcard(_reduxShip);

var _model = require('./model');

var Model = _interopRequireWildcard(_model);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = [control].map(regeneratorRuntime.mark);

function control(action) {
  return regeneratorRuntime.wrap(function control$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield(Ship.commit(action), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/controller.js
 ** module id = 60
 ** module chunks = 0
 **/